import Grid from "@mui/material/Grid";
import TopGridBox from "./topGridBox";
import Box from "@mui/material/Box";
import {
  StyledGridLayout,
  MonitoredGridContainer,
  UnMonitoredGridContainer,
  MonitoredAssetGridItem,
} from "./gridPageLayout.styled";

export interface GridBoxInfo {
  num?: number;
  type?: string;
  color?: string;
  isSelected?: boolean;
  Icon?: JSX.Element;
  monitored?: { label: string; num: string };
  unmonitored?: { label: string; num: string };
  iconName? : string
}

function GridPageLayout(info: GridBoxInfo[]) {
  info = Object.values(info);
  
  const customAssetsGridBox = (dataItem) => {
    return (
      <>
        <MonitoredGridContainer container>
          <Grid item sm={6}>
            {dataItem.monitored.label}
          </Grid>
          <MonitoredAssetGridItem item sm={6}>
            {dataItem.monitored.num}
          </MonitoredAssetGridItem>
        </MonitoredGridContainer>
        <UnMonitoredGridContainer container>
          <Grid item sm={6}>
            {dataItem.unmonitored.label}
          </Grid>
          <MonitoredAssetGridItem item sm={6}>
            {dataItem.unmonitored.num}
          </MonitoredAssetGridItem>
        </UnMonitoredGridContainer>
      </>
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledGridLayout container>
        {info.map((i, index) => (
          <Grid  rowSpacing={1}  item sm key={index} gap={1}>
            <TopGridBox
                num={i.num}
                type={i.type}
                iconName={i.iconName}
                color={i.color}
              />
          </Grid>
        ))}
      </StyledGridLayout>
    </Box>
  );
}

export default GridPageLayout;
